import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { Version, GetVersionResponse, SaveVersionRequest, SaveVersionResponse, DeleteVersionRequest, DeleteVersionResponse, UpdateVersionRequest } from "../../models/basics/version.models";

@autoinject
export class VersionService{

    constructor(private requestClient: RequestClientService){}

    public getVersions(): Promise<GetVersionResponse> {
        const request = {};

        return this.requestClient.get<GetVersionResponse>("version", request);
    }

    public getVersionsCount() : Promise<number> {
        const request = {};
        return this.requestClient.get<number>("version/GetCount", request);
    }

    public saveVersion(version: Version): Promise<SaveVersionResponse> {
        const request: SaveVersionRequest = {
            version: version
        };

        return this.requestClient.post<SaveVersionResponse>("version", {}, request)
    }

    public editVersion(version: Version): Promise<SaveVersionResponse> {
        const request: UpdateVersionRequest = {
            version: version
        };

        return this.requestClient.put<SaveVersionResponse>("version", {}, request);
    }

    public deleteVersion(version: Version): Promise<DeleteVersionResponse> {
        const request: DeleteVersionRequest = {
            version: version
        };

        return this.requestClient.delete<DeleteVersionResponse>("version", {}, request)
    }

    public getLatestVersion() : Promise<string> {
        const request = {};
        return this.requestClient.get<string>("version/GetLatestVersion", request);
    }
}